import { CategoriesQuery } from '../../graphql/graphql';

export interface GeneralAdsPageProps {
  transformedObj: {
    filter: { [key: string]: boolean | string };
    sorting?: string;
  };
  setErrorUI: (value: boolean) => void;
  h1?: string;
  totalAdsCount?: number;
  categories?: CategoriesQuery['categories'];
}

export enum PriceViewMode {
  PerArea = 'perArea',
  PerAcre = 'perAcre'
}

export interface ToggleOption {
  id: PriceViewMode;
  name: string;
}
